import React, { Component } from 'react';
import {Form, FormGroup, FormControl, Button} from 'react-bootstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAPIPath, USER_TYPE, headersWithMethod, fetchAPI } from '../../constants';
import { fetchUser } from '../../redux/auth/actions/auth';
// Css 
import './LoginView.css';

// Modules 
import Loading from '../../Modules/Loading';
const APIPATH = getAPIPath(USER_TYPE.RESET);

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  auth: PropTypes.object
};

class LoginView extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            email: '',
            password: '',
            isLoggedIn: false, 
            loading: false
        }

        this.handleSignIn = this.handleSignIn.bind(this);
        this.setLoading = this.setLoading.bind(this);

    }
    
    setLoading(isLoading) {
        this.setState({
            loading: isLoading
        })
    }

    async handleSignIn(e) {
        e.preventDefault();
        const { email, password } = this.state;
        if (this.validateEmailPassword()) {
            // Fetch user attribute based on email
            const result = await fetchAPI(APIPATH + "/findUser/" + this.state.email, headersWithMethod('GET'), this.props);
            const response = await result.json();
            console.log("response-", response);
            if (response.userDetails.Users.length === 0) {
                alert('User does not exist');
                return;
            }
            else {
                const diffInDays = await this.calculateUserLastUpdatedPwdDays(response);
                if (diffInDays >= 90) {
                    // await administrationService.forceChangePassword(email.toLowerCase())
                    const userResult = await fetchAPI(APIPATH + "/setUserPassword/" + this.state.email, headersWithMethod('GET'), this.props);
                   // console.log("userResult-", userResult);
                   alert('Your Password has expired. Please click on forgot your password link to reset password');
                   return;
                } else if (diffInDays >= 85) {
                    const daysLeft = 90 - parseInt(diffInDays);
                    alert(`Your Password is going to expire in ${daysLeft} days. Please click on forgot your password link to reset password`);
                }
            }
            this.props.dispatch(fetchUser({ email, password }));
        }
    }

    handleChange(column, value) {
        const newState = {};
        newState[column] = value;

        this.setState(newState);
    }

    resetPassword() {
        window.location.href = '/reset';
    }

    validateEmailPassword() {
        if (this.state.email === '') {
            alert('Please enter an email address');
            return false; 
        }
        if(this.state.email.indexOf('@') === -1 || this.state.email.indexOf('.') === -1) {
            alert('Please enter a valid email address');
            return false;
        }
        if(this.state.email.indexOf(' ') !== -1) {
            alert('Please enter a valid email address');
            return false;
        }
        if(this.state.password === '') {
            alert('Please enter a password');
            return false;
        }
        return true; 
    }

    async calculateUserLastUpdatedPwdDays(userResponse) {
        try {
            const customPwdLastModifiedDate = userResponse.userDetails.Users[0].Attributes.find(attr => attr.Name === "custom:pwdLastModifiedDate").Value;
            if(customPwdLastModifiedDate === null) {
                return 0;
            }
            const currentDate = new Date();
            const lastModifiedDate = new Date(customPwdLastModifiedDate)
            // Calculate the difference in milliseconds
            const diffInMs = currentDate.getTime() - lastModifiedDate.getTime()
            // Convert the difference from milliseconds to days
            const days = Math.floor(diffInMs / (1000 * 60 * 60 * 24))
            return days
        } catch (error) {
            console.log("error details- " + error)
            throw new Error(error);
        }
    }

    render() {

        const { auth } = this.props;        

        return(
            <div id="login-view">
                <div className="loginLogo"></div>
                <div className="loginContainer">                    
                    <div className="titleContainer">
                        <h2>Secure Login</h2>
                        <p>Enter your login details to gain access to your secure submission portal.</p>
                        {auth.error && <p className="error">{auth.error}</p>}
                    </div>
                    <div className="formContainer">                        
                        <Form onSubmit={e => this.handleSignIn(e)}>
                            <div className="padding">
                                <FormGroup controlId="formBasicText" className="form-group">
                                    <FormControl type="text" placeholder="Email address" onChange={e => this.handleChange('email', e.target.value.replace(/ /g,''))} className="username"/>                            
                                </FormGroup>
                                <FormGroup controlId="formPassword" className="form-group">
                                    <FormControl type="password" placeholder="Password"  autocomplete="off" onChange={e => this.handleChange('password', e.target.value.replace(/ /g,''))} className="password"/>
                                </FormGroup>                                
                            </div>
                            <FormGroup controlId="formPassword" className="form-group">
                                <Button type="submit" className="login-button">Login</Button>
                            </FormGroup>
                        </Form>
                    </div>
                    <Button type="button"  className="forgotLink btn-link" onClick={this.resetPassword.bind(this)}>Forgot your password?</Button>
                </div>   
                <Loading visible={this.state.loading} />  
            </div>
        );
    }
}

function select({ auth }) {
  return { auth };
}

LoginView.propTypes = propTypes;

export default connect(select)(LoginView); 
